import type { SVGProps } from "react";
import * as React from "react";
const SvgIntercom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#1F8DED"
      d="M19.333 12.996a.667.667 0 0 1-1.333 0V7a.667.667 0 0 1 1.333 0v5.996Zm-.232 4.173c-.103.088-2.573 2.16-7.101 2.16-4.528 0-6.997-2.072-7.1-2.16a.667.667 0 0 1 .866-1.014c.039.033 2.244 1.84 6.234 1.84 4.04 0 6.211-1.82 6.233-1.838a.667.667 0 0 1 .868 1.012ZM4.667 7A.667.667 0 0 1 6 7v5.996a.667.667 0 0 1-1.333 0V7ZM8 5.667a.667.667 0 0 1 1.333 0v8.906a.667.667 0 0 1-1.333 0V5.667Zm3.333-.338a.665.665 0 0 1 .922-.616.668.668 0 0 1 .412.616v9.667a.667.667 0 0 1-1.334 0V5.329Zm3.334.338a.667.667 0 0 1 1.333 0v8.906a.667.667 0 0 1-1.333 0V5.667ZM19.5 2h-15A2.5 2.5 0 0 0 2 4.5v15A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 19.5 2Z"
    />
  </svg>
);
export default SvgIntercom;
